import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorMessageComponent } from './components/error-message/error-message.component';
import { DateOnlyPipe } from './custom-pipe/date-only/date-only.pipe';
import { NairaCurrencyPipe } from './custom-pipe/naira-currency/naira-currency.pipe';
import { RemoveUnderscorePipe } from './custom-pipe/removeUnderscore/remove-underscore.pipe';
import { NgbModule, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmActionComponent } from './components/confirm-action/confirm-action.component';
import { LottieComponent, provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';
import { SuccessModalComponent } from './modals/success-modal/success-modal.component';
import { OnlyNumberDirective } from './directives/directives/only-number.directive';
import { UploadInputComponent } from './components/upload-input/upload-input.component';
import { BounceLoaderComponent } from './components/bounce-loader/bounce-loader.component';
import { AutoDataLabelDirective } from './directives/auto-data-label/auto-data-label.directive';
import { RemoveUnderscoreAndSpacePipe } from './custom-pipe/remove-underscore-and-space/remove-underscore-and-space.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { UnauthorizedAccessComponent } from './components/unauthorized-access/unauthorized-access.component';
import { SeparatorDirective } from './directives/directives/separator/separator.directive';
import { PaymentModalComponent } from './modals/payment-modal/payment-modal.component';
import { SignedPercentagePipe } from './custom-pipe/signed-percentage-pipe/signed-percentage.pipe';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { QueryModalComponent } from './modals/initial-application-approval-modal.component/query-modal.component';
import { NairaSeparatorDirective } from './directives/directives/nairaSeparator/naira.separator.directive';

import {
  Chart,
  registerables
} from 'chart.js';


import { BaseChartDirective } from "ng2-charts";
Chart.register(...registerables);
@NgModule({
  declarations: [
    SuccessModalComponent,
    DateOnlyPipe,
    NairaCurrencyPipe,
    RemoveUnderscorePipe,
    ConfirmActionComponent,
    ErrorMessageComponent,
    OnlyNumberDirective,
    UploadInputComponent,
    BounceLoaderComponent,
    AutoDataLabelDirective,
    RemoveUnderscoreAndSpacePipe,
    OnlyNumberDirective,
    NotFoundComponent,
    UnauthorizedAccessComponent,
    SeparatorDirective,
    NairaSeparatorDirective,
    PaymentModalComponent,
    SignedPercentagePipe,
    QueryModalComponent
  ],
  providers: [
    provideLottieOptions({
      player: () => player,
    }),
  ],
  imports: [
    CommonModule,
    NgbModule,
    LottieComponent,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    PdfViewerModule,
    BaseChartDirective
  ],
  exports: [
    DateOnlyPipe,
    NairaCurrencyPipe,
    RemoveUnderscorePipe,
    NgbModule,
    ConfirmActionComponent,
    SuccessModalComponent,
    ErrorMessageComponent,
    OnlyNumberDirective,
    UploadInputComponent,
    BounceLoaderComponent,
    AutoDataLabelDirective,
    RemoveUnderscoreAndSpacePipe,
    OnlyNumberDirective,
    NotFoundComponent,
    SeparatorDirective,
    NairaSeparatorDirective,
    SignedPercentagePipe,
    QueryModalComponent,
    
  ]
})
export class SharedModule { }
